import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

import Icon from '../Icon';

export const FilterButton = styled(Button)`
	&.greyOutline {
		background: transparent;
		border-color: var(--border-color);
		color: var(--content-2);

		:not(.disabled):hover {
			background: var(--blue);
			color: var(--white);
			border-color: var(--blue);

			.button-text,
			.button-icon {
				color: var(--white);
			}
		}
	}
`;

export const Divider = styled.div`
	border-bottom: 1px solid var(--border-color);
	margin: 2rem 0;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 33rem;
	@media ${Breakpoints.tablet} {
		width: 70%;
	}
`;

export const PageTag = styled.div`
	background-color: ${({ backgroundColor }) => `var(--${backgroundColor}-10)`};
	border: ${({ backgroundColor }) => `1px solid var(--${backgroundColor}-70)`};
	border-radius: 400px;
	padding: var(--padding-2) var(--padding-3);
	display: inline-block;
`;

export const WidgetContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
	border-radius: var(--small-border-radius);
	padding: var(--padding-3);
	justify-content: space-between;
	width: 100%;
	background: var(--background-3);
`;

export const SearchWrapper = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: minmax(20rem, 1fr) 23rem;
	margin-top: var(--margin-4);
	gap: 1rem;
	@media ${Breakpoints.tablet} {
		grid-template-columns: 1fr;
	}
`;

export const SettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	@media ${Breakpoints.tablet} {
		padding: var(--padding-4);
	}
`;

export const WidgetPreview = styled.div`
	padding: var(--padding-3);
	border-radius: var(--medium-border-radius);
	background: ${({ backgroundColor }) => backgroundColor || 'var(--border-color)'};
	color: var(--alwaysWhiteColor);

	@media ${Breakpoints.tablet} {
		padding: var(--padding-2);
	}
`;

export const ChartPreviewIcon = styled(Icon)`
	line-height: unset;
`;

export const WidgetContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	@media ${Breakpoints.tablet} {
		width: 100%;
	}
`;

export const WidgetHeader = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	justify-content: ${({ isEditingName }) => !isEditingName && 'space-between'};
	align-items: flex-start;
	width: 50rem;
	margin-bottom: var(--margin-2);
`;

export const WidgetOptionsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	width: 50rem;
`;

export const Option = styled.div`
	width: 50%;
`;

export const EditorButton = styled(Button)`
	flex-shrink: 0;
	width: 4rem;

	&.delete-copy-button {
		> div {
			color: var(--red) !important;
		}
	}
`;

export const ModalMenu = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	button {
		border: none;
		border-bottom: 2px solid var(--border-color);
		border-radius: 0;
		background: transparent;
	}
`;

export const Subtitle = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

export const PageHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
`;

export const List = styled.div`
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	gap: 1rem;
`;

export const DndIcon = styled(Icon)`
	cursor: move;

	@media ${Breakpoints.tablet} {
		cursor: unset;
	}
`;

export const PreviewPagesWidgetsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
